import { Component } from 'react';

import type { Conversation } from '../../../../types';
import BEM from 'common/bem';
import { ReactComponent as FlagIcon } from 'common/images/flag.svg';
import { mobxInjectSelect } from 'common/utils';

const classes = BEM.with('ConversationFlagIcon');

type ConversationFlagIconProps = {
  conversation: Conversation & {
    isFlagged?: boolean;
    network?: 'PROVIDER' | 'PATIENT';
  };
  isParentHovered: boolean;
};

type MobxProps = {
  toggleFlagConversation: (conversation: Conversation) => void;
  logFlagConversation: (conversation: Conversation, selectedFilter: string) => void;
  selectedFilter: string;
};

type CombinedProps = ConversationFlagIconProps & MobxProps;

type State = {
  isHovered: boolean;
};

class ConversationFlagIcon extends Component<CombinedProps, State> {
  state: State = {
    isHovered: false,
  };

  _onMouseEnter = (): void => {
    this.setState({ isHovered: true });
  };

  _onMouseLeave = (): void => {
    this.setState({ isHovered: false });
  };

  _onClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
    const { conversation, toggleFlagConversation, logFlagConversation, selectedFilter } =
      this.props;
    logFlagConversation(conversation, selectedFilter);
    toggleFlagConversation(conversation);
  };

  render() {
    const { conversation, isParentHovered } = this.props;
    const { isHovered } = this.state;
    const { isFlagged } = conversation;

    // Show if flagged OR if parent is hovered OR if this icon is hovered
    const shouldShow = isFlagged || isParentHovered || isHovered;
    const classConfig = { isFlagged, hidden: !shouldShow };
    const generatedClassName = classes(classConfig);

    return (
      <div
        data-test-id="conversation-flag-icon"
        className={generatedClassName}
        onClick={this._onClick}
        onMouseEnter={this._onMouseEnter}
        onMouseLeave={this._onMouseLeave}
        aria-label={isFlagged ? 'Unflag conversation' : 'Flag conversation'}
        role="button"
        style={{ opacity: shouldShow ? 1 : 0 }}
      >
        <FlagIcon />
      </div>
    );
  }
}

export default mobxInjectSelect<ConversationFlagIconProps, MobxProps>({
  conversationStore: ['toggleFlagConversation'],
  trackerStore: ['logFlagConversation'],
  rosterStore: ['selectedFilter'],
})(ConversationFlagIcon);
